import React from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
    const linkClass = "text-gray-600 hover:text-brand-primary font-medium transition-colors pb-1 border-b-2";
    const activeLinkClass = "text-brand-primary border-brand-accent";

    return (
        <header className="bg-white shadow-md sticky top-0 z-50">
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center gap-3">
                            <img className="h-10 w-10" src="/logo.png" alt="ABSSVSS Logo" />
                            <span className="font-bold text-xl text-brand-primary">ABSSVSS</span>
                        </Link>
                    </div>
                    <div className="flex items-center space-x-6">
                        <NavLink 
                            to="/" 
                            end // Add 'end' prop to prevent matching nested routes
                            className={({ isActive }) => `${linkClass} ${isActive ? activeLinkClass : 'border-transparent'}`}
                        >
                            Member Directory
                        </NavLink>
                        <NavLink 
                            to="/register" 
                            className={({ isActive }) => `${linkClass} ${isActive ? activeLinkClass : 'border-transparent'}`}
                        >
                            Register
                        </NavLink>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;

